module.exports = __webpack_public_path__ + "static/media/bingo-unscratched.9615ac04.jpg";